import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ServerPath } from '../../Constant';

const EditMultiyatraBelt = ({ show, onHide, templateData }) => {
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        status: '',
        blessing_text: '',
        image: null,
        action_button_label: '',
        priority: '',
        action_link: '',
        display_start_date: '',
        display_end_date: '',
        display_time: '',
        frequency: '',
        image_only: 0
    });

    const [imagePreview, setImagePreview] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const [newImage, setNewImage] = useState(null);
    const emojiPattern = /[\p{Emoji}]/u;

    // Initialize form data when component receives templateData
    useEffect(() => {
        if (templateData) {
            // Format dates for form inputs (YYYY-MM-DD)
            const formatDateForInput = (dateString) => {
                if (!dateString) return '';

                // If date contains time information (from database), extract just the date part
                if (dateString.includes(' ')) {
                    return dateString.split(' ')[0];
                }

                // Check if date is in DD-MM-YYYY format
                if (dateString.includes('-')) {
                    const parts = dateString.split('-');
                    if (parts.length === 3 && parts[0].length === 2) {
                        // Convert from DD-MM-YYYY to YYYY-MM-DD
                        return `${parts[2]}-${parts[1]}-${parts[0]}`;
                    }
                }

                // If already in YYYY-MM-DD format, return as is
                if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                    return dateString;
                }

                // For any other format, try to create a date and format it properly
                try {
                    const date = new Date(dateString);
                    if (!isNaN(date.getTime())) {
                        // Format manually to avoid timezone issues
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                    }
                } catch (e) {
                    console.error('Error parsing date:', e);
                }

                return '';
            };

            setFormData({
                title: templateData.title || '',
                category: templateData.category || '',
                status: templateData.status || '',
                blessing_text: templateData.blessing_text || '',
                image: null, // Will be set only if user uploads a new image
                action_button_label: templateData.action_button_label || '',
                priority: templateData.priority || '',
                action_link: templateData.action_link || '',
                display_start_date: formatDateForInput(templateData.display_start_date),
                display_end_date: formatDateForInput(templateData.display_end_date),
                display_time: templateData.display_time || '',
                frequency: templateData.frequency || '',
                image_only: templateData.image_only || 0
            });

            setCharCount(templateData.blessing_text?.length || 0);

            // Set image preview if available
            if (templateData.image || templateData.thumbnail_url) {
                setImagePreview(templateData.image || templateData.thumbnail_url);
            }
        }
    }, [templateData]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        if ((name === 'title' || name === 'blessing_text')) {
            // Check if the new value has an emoji that wasn't in the previous value
            if (emojiPattern.test(value) && !emojiPattern.test(formData[name])) {
                toast.error('Emojis are not allowed in text fields');
                return;
            }
        }

        if (name === 'category' && value === 'Live Aarti') {
            // When Live Aarti is selected, set current time as default if not already set
            if (!formData.display_time) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    display_time: new Date().toTimeString().slice(0, 5) // Sets current time in HH:MM format
                }));
                return;
            }
        } else if (name === 'category' && value !== 'Live Aarti') {
            // When switching away from Live Aarti, clear the time
            setFormData(prev => ({
                ...prev,
                [name]: value,
                display_time: ''
            }));
            return;
        }
        if (name === 'display_start_date' || name === 'display_end_date') {
            const startDate = name === 'display_start_date' ? value : formData.display_start_date;
            const endDate = name === 'display_end_date' ? value : formData.display_end_date;

            // Only validate if both dates are selected
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (end < start) {
                    toast.error('End date cannot be earlier than start date');
                    return;
                }
            }
        }

        // Normal handling for other fields
         setFormData(prev => ({
                ...prev,
                [name]: name === 'image_only' ? (checked ? 1 : 0) : value // <-- THIS IS THE KEY FIX
            }));

        // Update character count for blessing text
        if (name === 'blessing_text') {
            setCharCount(value.length);
        }
    };

    // Handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file size (max 3MB)
            if (file.size > 3 * 1024 * 1024) {
                toast.error('Image size should be less than 3MB');
                return;
            }

            // Check file type
            const fileType = file.type.toLowerCase();
if (!fileType.includes('jpeg') && !fileType.includes('jpg') && !fileType.includes('png') && !fileType.includes('webp')) {
    toast.error('Only JPG/PNG/WEBP files are allowed');
    return;
}

            setNewImage(file);

            // Create image preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        const requiredFields = [
            // { name: 'title', label: 'Title' },
            { name: 'category', label: 'Category' },
            // { name: 'blessing_text', label: 'Blessing Text' },
            { name: 'priority', label: 'Priority' },
            { name: 'display_start_date', label: 'Display Start Date' },
            { name: 'frequency', label: 'Frequency' },
            { name: 'action_link', label: 'Action link/URL' }
        ];

        for (const field of requiredFields) {
            if (!formData[field.name]) {
                toast.error(`Please fill in ${field.label}`);
                return;
            }
        }

        // If action_link is provided, action_button_label is required
        // if (formData.action_link && !formData.action_button_label) {
        //     toast.error('Please select an Action Button Label when providing an Action Link');
        //     return;
        // }

        // Character limits
        if (formData.image_only === 0) {
        if (formData.title.length > 30) {
            toast.error('Title must be 30 characters or less');
            return;
        }

        if (formData.blessing_text.length > 50) {
            toast.error('Blessing Text must be 50 characters or less');
            return;
        }
     }
        // Special validation for Live Aarti category
        if (formData.category === 'Live Aarti' && !formData.display_time) {
            toast.error('Time is required for Live Aarti category');
            return;
        }

        if (formData.display_start_date && formData.display_end_date) {
            const startDate = new Date(formData.display_start_date);
            const endDate = new Date(formData.display_end_date);

            if (endDate < startDate) {
                toast.error('End date cannot be earlier than start date');
                return;
            }
        }

        try {
            setIsLoading(true);

            // Create JSON data for regular fields
            const updateData = {
                template_id: templateData?.template_id,
                title: formData.title,
                category: formData.category,
                status: formData.status,
                blessing_text: formData.blessing_text,
                action_button_label: formData.action_button_label || null,
                priority: formData.priority,
                action_link: formData.action_link || null,
                // More robust date formatting
                display_start_date: formData.display_start_date || null,
                display_end_date: formData.display_end_date || null,
                display_time: formData.display_time || null,
                frequency: formData.frequency,
                image_only: formData.image_only
            };

            console.log("Updating with data:", updateData);

            // Handle image upload if there's a new image
            if (newImage) {
                const reader = new FileReader();
                reader.readAsDataURL(newImage);
                reader.onloadend = async () => {
                    const base64Data = reader.result.split(',')[1]; // Get base64 part after comma

                    // Add image data to the updateData object
                    updateData.thumbnailContent = base64Data;
                    updateData.thumbnailType = newImage.type;

                    try {
                        // Call API with updateData
                        const response = await axios.put(`${ServerPath}/kuber-belt/${templateData.template_id}`, updateData);

                        if (response.data.success) {
                            toast.success('Template updated successfully');
                            onHide(); // Close modal after successful update
                        } else {
                            toast.error(response.data.message || 'Failed to update template');
                            setIsLoading(false);
                        }
                    } catch (apiError) {
                        console.error('API error:', apiError);
                        toast.error(apiError.response?.data?.message || 'Failed to update template');
                        setIsLoading(false);
                    }
                };

                reader.onerror = (error) => {
                    console.error('Error reading file:', error);
                    toast.error('Error processing image');
                    setIsLoading(false);
                };
            } else {
                // No new image to process - FIXED VERSION: sending updateData instead of templateData
                const response = await axios.put(`${ServerPath}/kuber-belt/${templateData.template_id}`, updateData);

                if (response.data.success) {
                    onHide(); // Close modal after successful update
                    window.location.reload();
                    toast.success('Template updated successfully');
                } else {
                    toast.error(response.data.message || 'Failed to update template');
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error updating template:', error);
            toast.error(error.response?.data?.message || 'Failed to update template');
            setIsLoading(false);
        }
    };

    // Category options
    const categoryOptions = [
        'Daily Blessing',
        'Festival',
        'Quote',
        'Promotion',
        'Live Aarti',
        'Ad'
    ];

    // Status options
    const statusOptions = [
        'Active',
        'Archive'
    ];

    // Frequency options
    const frequencyOptions = [
        'Once',
        'Daily',
        'Weekly',
        'Monthly',
        'Quarterly',
        'Half-Yearly',
        'Annually'
    ];

    // Action button label options
    const actionButtonOptions = [
        'Click Here',
        'Know More',
        'Read More',
        'Watch Now',
        'Live Darshan',
        'See Details',
        'Learn More',
        'Buy Now',
        'Donate Now',
        'Sponsor Pooja',
        'Talk to Guru',
        'Take Course',
        'Join Live',
        'Plan Your Trip'
    ];

    // Final corrected date formatting function
    const formatDisplayDate = (dateString) => {
        // This function now correctly handles the "DD-MM-YYYY" format.
        if (!dateString || typeof dateString !== 'string') return 'NA';

        // Split the date string "DD-MM-YYYY" into parts.
        const parts = dateString.split(' ')[0].split('-'); // Handles "DD-MM-YYYY HH:MM:SS" as well

        if (parts.length === 3) {
            const day = parts[0];
            const month = parts[1];
            const year = parts[2];

            // Check if the parts look like a valid DD-MM-YYYY date
            if (day.length === 2 && month.length === 2 && year.length === 4) {
                // Return the already correct format
                return `${day}/${month}/${year}`;
            }
        }

        // --- Fallback for other date formats like YYYY-MM-DD ---
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }

        // If all parsing fails, return the original string.
        return dateString;
    };

    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>Edit Template</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px' }}>
                <Form onSubmit={handleSubmit}>
                    <div className="mb-0" style={{ width: '100%' }}>
                        <div className="row">
                            <div className="col-md-4 text-start">
                                <div className="mb-3">
                                    <div style={{ fontSize: '16px', fontWeight: '500' }}>
                                        Template ID - {templateData?.template_id || 'TMP-0000000001'}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-center">
                                <div className="mb-3">
                                    <div style={{ fontSize: '16px', fontWeight: '500' }}>
                                        Record Creation Date - {formatDisplayDate(templateData?.created_date)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-end">
                                <div className="mb-3">
                                    <div style={{ fontSize: '16px', fontWeight: '500' }}>
                                        Last Update Date - {formatDisplayDate(templateData?.updated_date) || 'NA'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   <Row className="mb-3">
                            <Col md={6}>
                                <Form.Check
                                    type="checkbox"
                                    id="hasContainer"
                                    label="Image Only"
                                    name="image_only"
                                    checked={formData.image_only === 1 ? true : false}
                                    onChange={ handleChange}
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#4A5568'
                                    }}
                                />
                            </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: formData.image_only === 1 ? '#8794abff':'#4A5568', fontWeight: '500', fontSize: '16px' }} >
                                    Title <span className="text-danger">*</span>
                                    <span className="text-muted ms-2" style={{ fontSize: '12px' }}>
                                        (Character limit of 30 characters)
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    placeholder="Enter Title"
                                    maxLength={30}
                                    disabled={formData.image_only === 1 ? true : false}
                                    style={{
                                        height: '46px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '6px'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Category <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    style={{
                                        height: '46px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '6px'
                                    }}
                                >
                                    <option value="">Select category</option>
                                    {categoryOptions.map((option, index) => (
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Status <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    style={{
                                        height: '46px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '6px'
                                    }}
                                >
                                    <option value="">Select status</option>
                                    {statusOptions.map((option, index) => (
                                        <option key={index} value={option}>{option}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: formData.image_only === 1 ? '#8794abff':'#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Blessing Text <span className="text-danger">*</span>
                                    <span className="text-muted ms-2" style={{ fontSize: '12px' }}>
                                        (Character limit of 50 characters)
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="blessing_text"
                                    value={formData.blessing_text}
                                    onChange={handleChange}
                                    placeholder="Enter Blessing Text"
                                    maxLength={50}
                                    disabled={formData.image_only === 1 ? true : false}
                                    style={{
                                        height: '150px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '6px',
                                        resize: 'none'
                                    }}
                                />
                                <div className="text-end text-muted mt-1" style={{ fontSize: '12px' }}>
                                    {charCount}/50
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Image
                                </Form.Label>
                                <div
                                    style={{
                                        height: '150px',
                                        border: '1px dashed #E2E8F0',
                                        backgroundColor: '#F8F9FA',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                    onClick={() => document.getElementById('imageUpload').click()}
                                >
                                    {imagePreview ? (
                                        <img
                                            src={imagePreview}
                                            alt="Preview"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    ) : (
                                        <div className="text-center">
                                            <div style={{ fontSize: '24px', color: '#A0AEC0' }}>+</div>
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        id="imageUpload"
                                        accept="image/jpeg,image/png,image/webp"
                                        onChange={handleImageChange}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Action link/URL <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="action_link"
                                    value={formData.action_link}
                                    onChange={handleChange}
                                    placeholder="Enter Action link/URL"
                                    style={{
                                        height: '46px',
                                        border: '1px solid #E2E8F0',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '6px'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        {/* {formData.action_link ? (
                            <>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Action Button Label <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="action_button_label"
                                            value={formData.action_button_label}
                                            onChange={handleChange}
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        >
                                            <option value="">Select action button Label </option>
                                            {actionButtonOptions.map((option, index) => (
                                                <option key={index} value={option}>{option}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Priority <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="priority"
                                            value={formData.priority}
                                            onChange={handleChange}
                                            placeholder="Enter Priority"
                                            min="1"
                                            max="10"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </>
                        ) : ( */}
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Priority <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="priority"
                                        value={formData.priority}
                                        onChange={handleChange}
                                        placeholder="Enter Priority"
                                        min="1"
                                        max="10"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        {/* )} */}
                    </Row>

                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Display Start Date <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="date"
                                        name="display_start_date"
                                        value={formData.display_start_date}
                                        onChange={handleChange}
                                        min={new Date().toISOString().slice(0, 10)}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            paddingRight: '30px'
                                        }}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                    Display End Date
                                </Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="date"
                                        name="display_end_date"
                                        value={formData.display_end_date}
                                        onChange={handleChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            paddingRight: '30px'
                                        }}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        {formData.category === 'Live Aarti' ? (
                            // When Live Aarti is selected - show Time in 3rd position, Frequency in 4th
                            <>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Time <span className="text-danger">*</span>
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="time"
                                                name="display_time"
                                                value={formData.display_time}
                                                onChange={handleChange}
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px',
                                                    paddingRight: '30px'
                                                }}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Frequency <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="frequency"
                                            value={formData.frequency}
                                            onChange={handleChange}
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        >
                                            <option value="">Select frequency</option>
                                            {frequencyOptions.map((option, index) => (
                                                <option key={index} value={option}>{option}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </>
                        ) : (
                            // When Live Aarti is NOT selected - show Frequency in 3rd position, nothing in 4th
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Frequency <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="frequency"
                                        value={formData.frequency}
                                        onChange={handleChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="">Select frequency</option>
                                        {frequencyOptions.map((option, index) => (
                                            <option key={index} value={option}>{option}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}
                    </Row>
                </Form>
            </Modal.Body>
            <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    style={{
                        backgroundColor: '#5662F6',
                        borderColor: '#5662F6',
                        borderRadius: '6px',
                        padding: '10px 40px',
                        fontWeight: '500',
                        fontSize: '16px'
                    }}
                >
                    {isLoading ? 'Updating...' : 'Update'}
                </Button>
            </div>
        </Modal>
    );
};

export default EditMultiyatraBelt;